import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M18.5 0h-13A2.5 2.5 0 0 0 3 2.5v19A2.5 2.5 0 0 0 5.5 24h13a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0m.5 18.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-13A1.5 1.5 0 0 1 6.5 4h11A1.5 1.5 0 0 1 19 5.5Z"
    }, null, -1)
  ]));
}
const computerDeviceMobileTablet = { render };
export {
  computerDeviceMobileTablet as default,
  render
};
//# sourceMappingURL=computer-device-mobile-tablet.svg.js.map
